<template>
	<div class="container-fluid">
		<div class="row">
			<section id="tw-view-404" class="flex-grow-1">
				<div class="bg-white">
					<div class="p-4 py-5">
						<div class="d-flex justify-content-center my-5 py-5">
							<img src="@/assets/images/403.svg" width="40%" alt="" />
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Page403',
		components: {

		},
		data: () => ({

		}),
		mounted() {
            const path = this.$route.params.pathMatch;
            history.replaceState(null, null, path);
		},
		methods: {

		},
		mixins: []
    }
</script>